import React, {Fragment} from 'react';
import {Icon, Button} from 'components';
import {size, sortBy, useFormikContext} from 'helpers';
import css from './submit.module.scss';

const DIRTY = 0;
const SUBMITTING = 1;
const DEFAULT = 2;

export function Submit({ children, disabled, className, icon, useState = useFormikContext, ...props }) {
  const { isValid, isSubmitting, dirty } = useState();
  const state = isSubmitting ? SUBMITTING : (dirty ? DIRTY : DEFAULT);
  const longest = sortBy(children, size).pop();
  // const hasDirtyState = children.length >= 3;
  // active={!hasDirtyState || dirty}
  return (
    <Button disabled={isSubmitting || disabled} type="submit" {...props} className={[!isValid && 'muted', className, 'primary', disabled && css.disabled]}>
      { children &&
        <Fragment>
          <span className={css.placeholder}>
            <Icon name="empty" />
            { longest }
            <Icon name="empty" />
          </span>
          <span className={css.label}>
            { state == SUBMITTING && <Icon name="spinner" /> }
            { state == DEFAULT && Boolean(children[state]) && <Icon name="check" /> }
            { children[state] || children[DIRTY] }
          </span>
        </Fragment>
      }
      { icon &&
        <Icon name={isSubmitting ? 'spinner' : icon} />
      }
    </Button>
  );
}
